import { render, staticRenderFns } from "./settingProjectType.vue?vue&type=template&id=03414b7a&"
import script from "./settingProjectType.vue?vue&type=script&lang=js&"
export * from "./settingProjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports